import { render, staticRenderFns } from "./PresentLevelsConclusionTabs.vue?vue&type=template&id=1c403c20&scoped=true"
import script from "./PresentLevelsConclusionTabs.vue?vue&type=script&lang=js"
export * from "./PresentLevelsConclusionTabs.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsConclusionTabs.vue?vue&type=style&index=0&id=1c403c20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c403c20",
  null
  
)

export default component.exports